<template>
  <el-dialog
    class="radish-dia"
    title="职能模块确认"
    :modal="false"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
  >
    <div v-if="cates.length > 0" class="radish-dia-body" style="padding-bottom: 15px;">
      <div>以下是该文件的建议职能模块，请选择正确的职能模块</div>
      <el-checkbox-group v-model="selectedCates" @change="cateChange">
        <el-checkbox v-for="(cate, k) in cates" :key="`${k}-职能模块`" :label="cate"></el-checkbox>
      </el-checkbox-group>
    </div>
    <div v-if="cates.length > 0" class="radish-dia-body" style="padding-bottom: 15px;">
      <div>以下是该文件的建议细分职能，请选择正确的细分职能</div>
      <el-checkbox-group v-model="selectedXifens" @change="xifenChange">
        <el-checkbox v-for="(xifen, k) in xifens" :key="`${k}-细分职能`" :label="xifen"></el-checkbox>
      </el-checkbox-group>
    </div>
    <div v-if="hasTagSelect">
      <template v-for="(f, fk) in tagOptions">
        <formItem
          :ref="f.label"
          :key="fk"
          :type="f.type"
          :is-inline="true"
          :width="f.width"
          :label="f.label"
          :options="f.options"
          :content="defaultData[fk]"
          :handle-data-change="handleItemChange"
        />
      </template>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="cancel">都不是</el-button>
      <el-button size="mini" type="primary" @click="ok">确定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { locations, 业绩 } from '../../../project/src/constant/type'

export default {
  props: {
    handleConfirm: { type: Function, default: () => {} },
    hasTagSelect: { type: Boolean, default: false },
  },
  data() {
    return {
      rid: '',
      file: {},
      dialogVisible: false,
      cates: [],
      xifens: [],
      selectedCates: [],
      selectedXifens: [],
      defaultData: {},
      tagOptions: {
        职能模块: {
          label: '职能模块',
          width: '25%',
          type: 'multSelect',
          options: app.categories ? app.categories.map(v => v['名称']) : [],
        },
        细分职能: {
          label: '细分职能',
          width: '25%',
          type: 'multSelect',
          option: [],
        },
        擅长方向: {
          label: '擅长方向',
          width: '25%',
          type: 'multSelect',
          option: [],
        },
        行业: {
          label: '行业',
          width: '25%',
          type: 'select',
          options: app.industries || [],
        },
        平台: {
          label: '平台',
          width: '25%',
          type: 'select',
          options: ['A', 'B', 'C'],
        },
        业绩: {
          label: '业绩',
          width: '25%',
          type: 'select',
          options: 业绩,
        },
        职级: {
          label: '职级',
          width: '25%',
          type: 'select',
          options: {
            '1': '1.高管',
            '2': '2.部门总',
            '3': '3.部门副总/总助/团队长',
            '4': '4.部门核心骨干',
            '5': '5.新人三年以下',
          },
        },
        地域: {
          label: '地域',
          width: '25%',
          type: 'multSelect',
          options: locations,
        },
      },
    }
  },
  methods: {
    show(rid, file) {
      this.rid = rid
      this.file = file
      console.log('show', rid, file)
      if (file.标签预测 && file.标签预测.建议职能模块 && file.标签预测.建议职能模块.length > 0) {
        this.cates = file.标签预测.建议职能模块
        this.selectedCates = []
        if (file.标签预测 && file.标签预测.建议细分职能 && file.标签预测.建议细分职能.length > 0) {
          this.xifens = file.标签预测.建议细分职能
          this.selectedXifens = []
        } else {
          this.xifens = []
          this.selectedXifens = []
        }
        this.dialogVisible = true
      } else {
        this.cates = []
        this.selectedCates = []
        this.handleConfirm(rid, file)
      }
    },
    cancel() {
      this.handleConfirm(this.rid, this.file)
    },
    async ok() {
      if (!this.hasTagSelect && this.selectedCates.length == 0) {
        return this.$message('请至少选择一个职能模块或点击都不是')
      }
      let $addToSet = {}
      const $set = {}
      if (this.hasTagSelect) {
        Object.keys(this.defaultData).forEach(key => {
          if (key) {
            const val = this.defaultData[key]
            if (key && Array.isArray(val)) {
              $addToSet[key] = { $each: val }
            } else if (key && typeof val === 'string') {
              $set[key] = val
            }
          }
        })
      } else {
        $addToSet = { 职能模块: { $each: this.selectedCates } }
      }
      const params = { _id: this.rid, $addToSet }
      if (Object.keys($set).length > 0) {
        params.data = $set
      }
      await app.service('radish').modifyById(params)
      this.handleConfirm(this.rid, this.file)
      this.dialogVisible = false
    },
    handleItemChange: function(res) {
      const { label, content } = res
      if (label == '职能模块') {
        const currentCat = app.categories.filter(cat => content.includes(cat['名称']))
        if (currentCat.length > 0) {
          let znArr = []
          let scArr = []
          currentCat.forEach(cat => {
            if (cat['二级职能'] && cat['二级职能'].length > 0) {
              znArr = znArr.concat(cat['二级职能'])
            }
            if (cat['擅长方向'] && cat['擅长方向'].length > 0) {
              scArr = scArr.concat(cat['擅长方向'])
            }
          })
          this.tagOptions['细分职能'].options = this.unique(znArr)
          this.tagOptions['擅长方向'].options = this.unique(scArr)
        }
        this.selectedCates = content.filter(c => this.cates.includes(c))
      }
      this.defaultData[label] = content
    },
    unique: function(arr) {
      return Array.from(new Set(arr))
    },
    cateChange(value) {
      if (this.hasTagSelect) {
        const oldCates = this.defaultData['职能模块'].filter(c => !this.cates.includes(c))
        const newCates = this.unique([...oldCates, ...this.selectedCates])
        // 必须刷新，否则更新滞后。。。
        this.defaultData = Object.assign({}, this.defaultData, { 职能模块: newCates })
        this.handleItemChange({ label: '职能模块', content: newCates })
      }
    },
    xifenChange(value) {
      if (this.hasTagSelect) {
        const oldXifens = this.defaultData['细分职能'].filter(c => !this.xifens.includes(c))
        const newXifens = this.unique([...oldXifens, ...this.selectedXifens])
        // 必须刷新，否则更新滞后。。。
        this.defaultData = Object.assign({}, this.defaultData, { 细分职能: newXifens })
        this.handleItemChange({ label: '细分职能', content: newXifens })
      }
    },
  },
}
</script>
